import revgen_logo from "../partners/revgen/logo.png";
import netrifi_logo from "../partners/netrifi/logo.png";
import default_logo from "../partners/default/signin.png";
import echo911_logo from "../partners/echo911/logo.png";
import semsim_logo from "../partners/semsim/logo.png";
import device_manager_logo from "../partners/default/device_manager_logo.png";
import { createTheme } from "@material-ui/core/styles";

const PARTNERS = [
  { name: "revgen", domain: "cloud.revgennetworks.com" },
  { name: "netrifi", domain: "cloud.netrifi.com" },
  { name: "echo911", domain: "vsim.echo911.com" },
  { name: "semsim", domain: "cloud.sem-sim.net" },
];

const getPartner = () => {
  for (const partner of PARTNERS) {
    if (partner.domain === window.location.host) {
      return partner.name;
    }
  }
};

export const isNetrifi = () => {
  return getPartner() === "netrifi";
};

export const isEcho911 = () => {
  return getPartner() === "echo911";
};

export const isSemsim = () => {
  return getPartner() === "semsim";
};

export const isDefaultPartner = () => {
  return getPartner() === undefined;
};

export const isRevgen = () => {
  return getPartner() === "revgen";
};

export const showSupportButton = () => {
  return isDefaultPartner() || isRevgen() || isNetrifi();
};

// True when the current partner is semsim AND the logged-in user has no
// elevated permissions (not a super admin, organization admin, or reseller
// manager). Used to hide admin-only UI for semsim end users.
export const isSemsimBasicUser = (userData) => {
  if (!isSemsim()) return false;
  let data = userData;
  if (data === undefined || data === null) {
    try {
      data = JSON.parse(localStorage.getItem("userData"));
    } catch (e) {
      data = null;
    }
  }
  if (!data) return false;
  return (
    !data.is_super_admin &&
    !data.is_organization_admin &&
    !data.is_reseller_manager
  );
};

export function getLogoPath() {
  const partner = getPartner();
  if (partner === "revgen") {
    return revgen_logo;
  } else if (partner === "netrifi") {
    return netrifi_logo;
  } else if (partner === "echo911") {
    return echo911_logo;
  } else if (partner === "semsim") {
    return semsim_logo;
  }
  return default_logo;
}

export function getHeaderLogo() {
  const partner = getPartner();

  if (partner === "revgen") {
    return revgen_logo;
  } else if (partner === "netrifi") {
    return netrifi_logo;
  } else if (partner === "echo911") {
    return echo911_logo;
  } else if (partner === "semsim") {
    return semsim_logo;
  }
  return device_manager_logo;
}

export function getTheme() {
  const partner = getPartner();

  if (partner === "revgen") {
    return revgenTheme;
  } else if (partner === "netrifi") {
    return netrifiTheme;
  } else if (partner === "semsim") {
    return semsimTheme;
  }
  return defaultTheme;
}

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#1D4354",
    },
    secondary: {
      main: "#6FDA44",
    },
    warning: {
      main: "#f44336",
    },
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  colors: {
    green: "#6FDA44",
    darkBlue: "#1D4354",
    grey: "#f2f2f2",
  },
});

const revgenTheme = createTheme({
  palette: {
    primary: {
      main: "#930622",
    },
    secondary: {
      main: "#000000",
    },
    warning: {
      main: "#f44336",
    },
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  colors: {
    green: "#6FDA44",
    darkBlue: "#1D4354",
    grey: "#f2f2f2",
  },
  overrides: {
    // Style sheet name ⚛️
    MuiAppBar: {
      // Name of the rule
      colorPrimary: {
        backgroundColor: "#9e9e9e",
      },
    },
  },
});

const netrifiTheme = createTheme({
  palette: {
    primary: {
      main: "#072c40",
    },
    secondary: {
      main: "#1a95bc",
    },
    warning: {
      main: "#f44336",
    },
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  colors: {
    green: "#6FDA44",
    darkBlue: "#1D4354",
    grey: "#f2f2f2",
  },
  //   overrides: {
  //     // Style sheet name ⚛️
  //     MuiAppBar: {
  //       // Name of the rule
  //       colorPrimary: {
  //         backgroundColor: "#9e9e9e",
  //       },
  //     },
  //   },
});

const semsimTheme = createTheme({
  palette: {
    primary: {
      main: "#1E4C9A", // Deep blue from "SS"
    },
    secondary: {
      main: "#2F6FD6",
    },
    warning: {
      main: "#f44336",
    },
    background: {
      default: "#f8fafc",
    },
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  colors: {
    blue: "#1E4C9A",
    lightBlue: "#2F6FD6",
    orange: "#F47B20",
    darkOrange: "#D95F0E",
    grey: "#f2f2f2",
    textDark: "#1a1a1a",
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#FFFFFF",
      },
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: "#1E4C9A",
        "&:hover": {
          backgroundColor: "#2F6FD6",
        },
      },
      containedSecondary: {
        backgroundColor: "#1E4C9A",
        "&:hover": {
          backgroundColor: "#1E4C9A",
        },
      },
    },
    MuiTab: {
      textColorInherit: {
        color: "#000000",
      },
      root: {
        color: "#000000",
      },
    },
  },
});
